import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const LOGO = "https://customer-assets.emergentagent.com/job_9b5e32bd-6e03-4600-841f-a63162f850e8/artifacts/w487gkes_lexorbit-logo.png.png";

export default function CTASection({ onTrialClick }) {
  return (
    <section id="cta" className="relative py-20 lg:py-28 overflow-hidden bg-[#080808]" data-testid="cta-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#C9A44C]/[0.04] rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] rounded-full border border-[rgba(201,164,76,0.06)] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full border border-[rgba(201,164,76,0.03)] border-dashed pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <img src={LOGO} alt="LexOrbit" className="h-14 mx-auto mb-7 opacity-85" />
          <h2 className="text-2xl sm:text-3xl lg:text-[2.6rem] font-medium text-[#F8F6F0] tracking-tight mb-5 leading-[1.15]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Digitalizá tu estudio jurídico con <span className="text-[#C9A44C] italic">LexOrbit</span>
          </h2>
          <p className="text-[#B8B8B8] text-sm sm:text-[15px] max-w-lg mx-auto mb-4 leading-relaxed">
            Creá tu organización, probá el sistema durante 5 días y empezá a gestionar tu despacho desde un entorno privado, seguro y profesional.
          </p>
          <p className="text-[#C9A44C]/50 text-[11px] tracking-wide mb-9">Sistema basado en una gestión jurídica real, preparado para abogados independientes y estudios profesionales.</p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={onTrialClick}
              className="group text-[#050505] px-8 py-4 rounded text-sm font-bold transition-all duration-300 flex items-center justify-center gap-2 hover:shadow-[0_0_35px_rgba(201,164,76,0.4)]"
              style={{ background: 'linear-gradient(135deg, #C9A44C, #E0C878)' }}
              data-testid="cta-trial-btn">
              Probar gratis 5 días <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </button>
            <a href="#planes" className="border border-[rgba(201,164,76,0.3)] text-[#F8F6F0] px-8 py-4 rounded text-sm font-medium hover:border-[#C9A44C]/60 hover:bg-white/[0.03] transition-all duration-300 text-center" data-testid="cta-plans-btn">
              Ver planes
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
